export const EMPLOYR_LOGIN_SESSION = "EMPLOYR_LOGIN_SESSION";
export const CORRELATION_ID = "CORRELATION_ID";
